<div class="card">
  <h1 class="display-name" role="heading" aria-level="1">{{ review.displayName }}</h1>
  <span class="date">{{ review.createdDate | date:'MMMM y' }}</span>
  <app-rating [rate]="review.rating" class="rating" color="var(--ion-color-drr-warning)"></app-rating>
  <h2 class="title" role="heading" aria-level="2">{{ review.title }}</h2>
  <p class="comments">{{ review.comments }}</p>
</div>
